module.exports = __webpack_public_path__ + "static/HospitalSultanahAminah-color-145754c578eb27b5df01c9dd20750498.png";